<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import { getDeliveryList } from "@/api/claim_management/deliveryCostQuery";

import cTable from "@/base/common/index";
export default {
  name: "deliveryCostQuery",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        list: getDeliveryList
      },
      config: {
        height: 630
      },
      footer: {
        show: () => false
      },
      modals: {},
      header: {
        config: {
          custom: false
        },
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 1 }
            }
          }
          // {
          //   key: "ClientId",
          //   type: "select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("clientName");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "account", value: "id" }
          // }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("orderNum"),
          key: "airway_number",
          align: "center",
          minWidth: 200
        },
        {
          name: () => this.$t("agentT"),
          key: "deliver",
          align: "center",
          minWidth: 200
        },
        {
          name: () => this.$t("deliveryCost_t"),
          key: "fee",
          minWidth: 160
        },
        {
          name: () => this.$t("currency_t"),
          key: "currency",
          minWidth: 160
        },
        {
          name: () => this.$t("DeclaredValue"),
          key: "values",
          minWidth: 160
        },
        {
          name: () => this.$t("from_country"),
          key: "from_country",
          minWidth: 160
        },
        {
          name: () => this.$t("target_country"),
          key: "to_country",
          minWidth: 160
        }
      ]
    };
  }
};
</script>
